import '../Styles/Footer.css'; // Puedes agregar estilos aquí

const Footer = () => {
    return (
        <footer className="dashboard-footer">
            <p>© 2024 Tu Empresa. Todos los derechos reservados.</p>
        </footer>
    );
};

export  {Footer};
